import ButtonSettingsNew from 'client/components/core/Sidebar/components/Settings/entities/button-settings'
import { SearchResultsSettings } from 'client/components/core/Sidebar/components/Settings/entities/search-results-settings'
import EntityTypeEnum from 'common/enums/entityTypeEnum'
import { BlogCategoryDescriptionInterface } from 'common/types/entities/BlogCategoryDescriptionInterface'
import { BlogCategoryTitleInterface } from 'common/types/entities/BlogCategoryTitleInterface'
import { BlogPostListingInterface } from 'common/types/entities/BlogPostListingInterface'
import { ButtonInterface } from 'common/types/entities/button-interface'
import { ContactUsInterface } from 'common/types/entities/ContactUsInterface'
import { ContactUsButtonInterface } from 'common/types/entities/contact-us-button-interface'
import EntityInterface from 'common/types/entities/EntityInterface'
import { FieldInterface } from 'common/types/entities/field-interface'
import { LatestBlogPostsCarouselInterface } from 'common/types/entities/LatestBlogPostsCarouselInterface'
import { LatestBlogPostsInterface } from 'common/types/entities/LatestBlogPostsInterface'
import { RecaptchaInterface } from 'common/types/entities/RecaptchaInterface'
import { SearchResultsInterface } from 'common/types/entities/search-results-interface'
import React from 'react'
import { SearchSettings } from 'src/editor/shared/entities/search/search-settings'
import { AttachmentsInterface } from 'src/shared/types/entities/attachments-interface'
import { SearchInterface } from 'src/shared/types/entities/search-interface'
import BaseTextEntitySettings from '../../components/core/Sidebar/components/Settings/BaseTextEntitySettings'
import RecaptchaSettings from '../../components/core/Sidebar/components/Settings/entities/RecaptchaSettings'
import AttachmentsSettings from '../contact-us/settings/AttachmentsSettings'
import ButtonSettings from '../contact-us/settings/ButtonSettings'
import ContactUsFieldSettings from '../contact-us/settings/ContactUsFieldSettings'
import ContactUsSettings from '../contact-us/settings/ContactUsSettings'
import createCommonEntitySettings from '../createCommonEntitySettings'
import BlogLatestPostsSettings from './settings/BlogLatestPostsSettings'
import BlogPostListingSettings from './settings/BlogPostListingSettings'
import LatestBlogPostsCarouselSettings from './settings/LatestBlogPostsCarouselSettings'

function createSettingsForBlogPage(
  entity: EntityInterface,
  defaultEntity?: EntityInterface,
) {
  switch (entity.type) {
    case EntityTypeEnum.BlogPostListing:
      return (
        <BlogPostListingSettings
          entity={entity as BlogPostListingInterface}
          defaultEntity={defaultEntity as BlogPostListingInterface}
        />
      )
    case EntityTypeEnum.SearchResults:
      return (
        <SearchResultsSettings
          entity={entity as SearchResultsInterface}
          defaultEntity={defaultEntity as SearchResultsInterface}
        />
      )
    case EntityTypeEnum.Search:
      return (
        <SearchSettings
          entity={entity as SearchInterface}
          defaultEntity={defaultEntity as SearchInterface}
        />
      )
    case EntityTypeEnum.LatestBlogPosts:
      return (
        <BlogLatestPostsSettings
          entity={entity as LatestBlogPostsInterface}
          defaultEntity={defaultEntity as LatestBlogPostsInterface}
        />
      )
    case EntityTypeEnum.BlogCategoryTitle:
      return (
        <BaseTextEntitySettings
          entity={entity as BlogCategoryTitleInterface}
          defaultEntity={defaultEntity as BlogCategoryTitleInterface}
        />
      )
    case EntityTypeEnum.BlogCategoryDescription:
      return (
        <BaseTextEntitySettings
          entity={entity as BlogCategoryDescriptionInterface}
          defaultEntity={defaultEntity as BlogCategoryDescriptionInterface}
        />
      )
    case EntityTypeEnum.ContactUs:
      return (
        <ContactUsSettings
          entity={entity as ContactUsInterface}
          defaultEntity={defaultEntity as ContactUsInterface}
        />
      )
    case EntityTypeEnum.Button:
      return (
        <ButtonSettingsNew
          entity={entity as ButtonInterface}
          defaultEntity={defaultEntity as ButtonInterface}
        />
      )
    case EntityTypeEnum.ContactUsButton:
      return (
        <ButtonSettings
          entity={entity as ContactUsButtonInterface}
          defaultEntity={defaultEntity as ContactUsButtonInterface}
        />
      )
    case EntityTypeEnum.ContactUsField:
      return (
        <ContactUsFieldSettings
          entity={entity as FieldInterface}
          defaultEntity={defaultEntity as FieldInterface}
        />
      )
    case EntityTypeEnum.Recaptcha:
    case EntityTypeEnum.ContactUsRecaptcha:
      return (
        <RecaptchaSettings
          entity={entity as RecaptchaInterface}
          defaultEntity={defaultEntity as RecaptchaInterface}
        />
      )
    case EntityTypeEnum.Attachments:
      return (
        <AttachmentsSettings
          entity={entity as AttachmentsInterface}
          defaultEntity={defaultEntity as AttachmentsInterface}
        />
      )
    case EntityTypeEnum.LatestBlogPostsCarousel:
      return (
        <LatestBlogPostsCarouselSettings
          entity={entity as LatestBlogPostsCarouselInterface}
          defaultEntity={defaultEntity as LatestBlogPostsCarouselInterface}
        />
      )
    default:
      return createCommonEntitySettings(entity, defaultEntity)
  }
}

export default createSettingsForBlogPage
